import React, { useCallback, useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import NumberInput from '../../../components/Input/NumberInput';
import ButtonAction from '../../../components/Button.js/SaveButton';
import Loader from '../../../components/loader/loader';
import TextInput from 'src/components/Input/TextInput';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ComboBox from 'src/components/Input/ComboBox';
import ChessBoardSelectCell from 'src/component-project/TableSelectedUser/ChessBoardSelectCell';
import { useParams } from 'react-router-dom';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const ConfirmFixDeviceModel = ({ visible = false, callBackFunct, setVisible, data, idPermission }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [flagProcess, setFlagProcess] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const [grindingTime, setGrindingTime] = useState(0);
    const [grindingPrice, setGrindingPrice] = useState(0);
    const [dataDrawer, setDataDrawer] = useState([]);
    const [dataCell, setDataCell] = useState([]);
    const [selectDrawer, setSelectDrawer] = useState(0);
    const [selectedCell, setSelectedCell] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [confirmInfo, setconfirmInfo] = useState(false);
    const isHandledRef = useRef(false);
    const [suggestCell, setSuggestCell] = useState(null);

    const isFinishSelectCell = selectDrawer !== 0 && selectedCell !== null && quantity !== null && grindingTime !== 0;
    const isFinishConfirmInfo = quantity !== null && grindingTime !== 0 && confirmInfo;
    const user = glb_sv.userInfo;
    const isAdmin = user?.group_user === '1';
    useEffect(() => {
        try {
            setDataDrawer([]);
            setDataCell([]);
            // getDataDrawer(data?.cabinet_id);
            setSuggestCell(null);
            setconfirmInfo(false);
            setSelectDrawer(0);
            setQuantity(data?.qty_change_request);
            setGrindingTime(0);
            setGrindingPrice(0);
            if (data?.cabinet_id && visible) {
                // isHandledRef.current = false;
                // if (isAdmin && data.status === 7) {
                //     getDataDrawer(data?.cabinet_request_id);
                // }
                // else getDataDrawer(data?.cabinet_id);
            }
            if (!visible) {
                clearIntervalCheckStatusCell();
            }
        } catch (e) {}
    }, [visible]);

    useEffect(() => {
        return () => {
            clearIntervalCheckStatusCell();
        };
    }, []);

    useEffect(() => {
        try {
            if (selectDrawer !== 0 && visible && confirmInfo) {
                setSelectedCell(null);
                getAllCell(data?.cabinet_id, selectDrawer);
            }

            if (selectDrawer === 0 && visible) {
                setDataCell([]);
                setSelectedCell(null);
            }
        } catch (e) {}
    }, [selectDrawer, visible, confirmInfo]);

    const getDataDrawer = useCallback(
        (id) => {
            const InVal = [id];
            sendRequest(serviceList.getAlldrawerSp, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
        },
        [data?.cabinet_id, selectDrawer, data?.id]
    );

    const getDataDrawerSuggest = useCallback(
        (id, device_cd) => {
            setFlagProcess(true);
            const InVal = [id, device_cd + '_ML' + grindingTime.toString().padStart(2, '0'), data?.drawer_request_id];
            sendRequest(serviceList.getListDrawerAndSuggestCell, InVal, getDataDrawerResult, true, timeOutFunct, 40000);
        },
        [data?.cabinet_id, visible, data?.device_cd, data?.drawer_request_id, grindingTime]
    );

    const getDataDrawerResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const drawerData = [...message.proc_data.rows[0].o_1];
            const drawerDataSuggest = message.proc_data?.suggest_drawer;
            const cellDataSuggest = message.proc_data?.suggest_cell;
            drawerData.map((ele) => {
                setDataDrawer((prev) => {
                    if (prev.some((item) => item.value === ele.id)) return prev;

                    return [
                        ...prev,
                        {
                            label: ele.drawer_nm,
                            value: ele.id,
                            lc: ele.drawer_lc,
                        },
                    ];
                });
            });
            setconfirmInfo(true);
            setSelectDrawer(drawerDataSuggest);
            setSuggestCell(cellDataSuggest);
        }
    };

    const getAllCell = useCallback(
        (id_capinet, id_drawer) => {
            const InVal = [idPermission, id_capinet, id_drawer];
            sendRequest(serviceList.getAllbox, InVal, getDataCellResult, true, timeOutFunct, 40000);
        },
        [data?.cabinet_id, selectDrawer, data?.cabinet_request_id, data?.id]
    );

    const getDataCellResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setDataCell([...message.proc_data.rows[0].o_1]);
            if (!suggestCell) {
                if (selectDrawer !== data?.drawer_request_id) {
                    setSelectedCell(
                        message.proc_data.rows[0].o_1.filter(
                            (ele) => ele.device_id === null && ele.block_status === '1'
                        )[0]
                    );
                } else {
                    setSelectedCell(message.proc_data.rows[0].o_1.filter((ele) => ele.id === data?.cell_request_id)[0]);
                }
            } else setSelectedCell(message.proc_data.rows[0].o_1.filter((ele) => ele.id === suggestCell)[0]);
        }
    };
    const handleClick = useCallback(() => {
        if (isHandledRef.current) return;
        clearIntervalCheckStatusCell();
        isHandledRef.current = true;
        setFlagProcess(true);
        const InVal = [
            data.device_id,
            parseInt(quantity),
            parseFloat(grindingPrice),
            parseInt(grindingTime),
            selectedCell.id,
            selectDrawer,
            data.cabinet_id,
            data.id,
        ];
        sendRequest(serviceList.confirm_grinding, InVal, actionResult, true, timeOutFunct, 40000);
    }, [
        data?.device_id,
        quantity,
        grindingPrice,
        grindingTime,
        selectedCell?.id,
        selectDrawer,
        data?.cabinet_id,
        data?.id,
    ]);

    const actionResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            closeCell();
            toast.success(message['proc_message']);
        }
    };

    const suggestPriceGrinding = useCallback(() => {
        const InVal = [data?.device_cd + '_ML' + grindingTime.toString().padStart(2, '0'), data?.cabinet_request_cd];
        sendRequest(serviceList.getByDeviceCode, InVal, suggestPriceGrindingResult, true, timeOutFunct, 40000);
    }, [data?.device_cd, data?.cabinet_request_cd, grindingTime]);

    const suggestPriceGrindingResult = (reqInfoMap, message) => {
        setFlagProcess(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            // toast.error('Error: ' + message['proc_message']);
            setGrindingPrice(0);
            return;
        } else {
            if (message?.proc_data?.rows[0]?.o_1?.price) {
                setGrindingPrice(message?.proc_data?.rows[0]?.o_1?.price);
            } else {
                setGrindingPrice(0);
            }
        }
    };

    // region open cell
    const openCell = (data) => {
        setFlagProcess(true);

        let service = serviceList.openCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === (data?.drawer_request_id || selectDrawer))?.lc;
        let inpuVal = [
            data.cabinet_request_cd || data.cabinet_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];

        if (data?.cabinet_type !== 'round') {
            service = serviceList.openCellIOT;
            inpuVal = [
                data.cabinet_request_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.openCellIOTCabinetV2;
            inpuVal = [
                data.cabinet_request_cd || data.cabinet_cd,
                drawer_lc_select,
                selectedCell.cell_lc.column,
                selectedCell.column,
            ];
        }
        sendRequest(service, inpuVal, openCellResult, true, timeOutFunct, 40000, 0);
    };

    const openCellResult = (reqInfoMap, message) => {
        console.log('reqInfoMap', reqInfoMap['input_param']);

        if ((message['proc_status']?.toString() || '0') === '0') {
            // closeCell();
            toast.error('Error: ' + message['proc_message']);
        } else {
            // isGivedevice ? handleActionGiveDevice() : handleActionDevice();
            setFlagProcess(false);
            setIsOpen(true);
            // gọi api kiểm tra trạng thái ô sau 5s
            const input_param = reqInfoMap['input_param'];
            // setTimeout(() => {
            handleIntervalCheckStatusCell(input_param[0], input_param[1], input_param[2]);
            // }, 5000);
        }
    };

    // region closeCell
    const closeCell = () => {
        let service = serviceList.closeCellIOT;
        const drawer_lc_select = dataDrawer.find((ele) => ele.value === ele.id)?.lc;
        clearIntervalCheckStatusCell();
        let inpuVal = [
            data.cabinet_request_cd,
            drawer_lc_select,
            selectedCell.cell_lc.row,
            selectedCell.cell_lc.column,
        ];
        if (data?.cabinet_type !== 'round') {
            service = serviceList.closeCellIOT;
            inpuVal = [
                data.cabinet_request_cd,
                drawer_lc_select,
                selectedCell.cell_lc.row,
                selectedCell.cell_lc.column,
            ];
        } else {
            service = serviceList.closeCellIOTCabinetV2;
            inpuVal = [data.cabinet_request_cd, drawer_lc_select, selectedCell.cell_lc.row, selectedCell.column];
        }
        sendRequest(service, inpuVal, closeCellResult, true, timeOutFunct, 40000, 0);
        // console.log('inpuValClose: ', inpuVal);
        // console.log('serviceListClose: ', service);
    };

    // region closeCellResult
    const closeCellResult = (reqInfoMap, message) => {
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
        } else {
            setIsOpen(false);
            setFlagProcess(false);
            callBackFunct && callBackFunct();
        }
        clearIntervalCheckStatusCell();
    };

    // region checkStatusCell START
    const checkIntervalCheckStatusCell = useRef(null);
    const checkStatusCellFlag = useRef(false);
    const handleIntervalCheckStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        checkIntervalCheckStatusCell.current = setInterval(() => {
            checkStatusCell(cabinet_cd, drawer_id, cell_address);
        }, 3000);
    };
    const clearIntervalCheckStatusCell = () => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        clearInterval(checkIntervalCheckStatusCell.current);
        checkIntervalCheckStatusCell.current = null;
        checkStatusCellFlag.current = false;
    };
    const checkStatusCell = (cabinet_cd, drawer_id, cell_address) => {
        console.log('checkIntervalCheckStatusCell.current', checkIntervalCheckStatusCell.current);
        if (!cabinet_cd || !drawer_id || !cell_address || checkStatusCellFlag.current) return;

        const inpuVal = [cabinet_cd, drawer_id, cell_address];
        sendRequest(
            serviceList.checkStatusCell,
            inpuVal,
            checkStatusCellResult,
            true,
            checkStatusCellTimeOut,
            40000,
            0
        );
    };
    const checkStatusCellResult = (reqInfoMap, message) => {
        checkStatusCellFlag.current = false;
        console.log(
            'checkStatusCellResult',
            (message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1'
        );
        if ((message['proc_code']?.toString() || '1') === '1' && (message['proc_status']?.toString() || '1') === '1') {
            handleClick();
        }
    };
    const checkStatusCellTimeOut = (reqInfo) => {
        setFlagProcess(false);
    };

    const timeOutFunct = (reqInfo) => {
        setFlagProcess(false);
        setIsOpen(false);
        toast.error(t('error.time_out'));
    };
    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            aria-labelledby="customized-dialog-title"
            PaperProps={{ component: 'div' }}
        >
            <BootstrapDialogTitle
                onClose={() => {
                    setVisible(!visible);
                }}
                id="customized-dialog-title"
            >
                {t('confirm_grinding_device')} <br /> {t('name_device')}: {data?.device_cd}_{data?.device_nm}
            </BootstrapDialogTitle>
            <Loader loading={flagProcess} />
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {/* <Grid item style={{ width: '100%' }} xs={4}>
                        <NumberInput
                            label={t("quantity_grinding")}
                            valueChange={quantity}
                            size="medium"
                            getValue={setQuantity}
                        />
                    </Grid> */}

                    <Grid item style={{ width: '100%' }} xl={4} md={4} sm={12}>
                        <NumberInput
                            label={t('time_grinding')}
                            valueChange={grindingTime}
                            size="medium"
                            getValue={setGrindingTime}
                            onEnterPress={() => {
                                suggestPriceGrinding();
                            }}
                        />
                    </Grid>

                    <Grid item style={{ width: '100%' }} xl={4} md={4} sm={12}>
                        <NumberInput
                            label={t('price_grinding')}
                            valueChange={grindingPrice}
                            size="medium"
                            getValue={setGrindingPrice}
                        />
                    </Grid>

                    {isFinishConfirmInfo && (
                        <Grid item xl={4} md={4} sm={12} style={{ width: '100%' }}>
                            <ComboBox
                                label={t('choose_drawer')}
                                sizeCbb="medium"
                                displayLabel="label"
                                valueEqual="value"
                                valueSelect={dataDrawer.find((ele) => ele.value === selectDrawer)}
                                getValue={(e) => setSelectDrawer(e?.value || 0)}
                                selectOption={dataDrawer}
                                required
                            />
                        </Grid>
                    )}

                    {dataCell.length > 0 && (
                        <>
                            <Typography variant="h5" sx={{ mt: 2, textAlign: 'center', width: '100%' }}>
                                {t('select_empty_cell')}
                            </Typography>
                            <Typography
                                variant="caption"
                                sx={{
                                    textAlign: 'center',
                                    display: 'block',
                                    fontStyle: 'italic',
                                    width: '100%',
                                    color: '#adb1b5',
                                }}
                            >
                                {t('cell_have_lock')}
                            </Typography>
                            <ChessBoardSelectCell
                                cell_id_request={data?.cell_request_id}
                                device_cd={data?.device_cd + '_ML' + grindingTime.toString().padStart(2, '0')}
                                typeCabinet={data?.cabinet_type}
                                onSelect={(pos) => {
                                    setSelectedCell(pos);
                                    console.log('Bạn đã chọn vị trí:', pos.cell_lc);
                                }}
                                dataCell={dataCell}
                                selectedCell={selectedCell}
                            />
                        </>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    onClick={() => {
                        setVisible(!visible);
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                {!isOpen ? (
                    <ButtonAction
                        disabled={!isFinishSelectCell}
                        onClick={() => {
                            openCell(data);
                            // handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('open_cell_input')}
                    />
                ) : (
                    <ButtonAction
                        onClick={() => {
                            handleClick();
                        }}
                        type={'confirm'}
                        icon="send"
                        title={t('confrim_success')}
                    />
                )}
                {!isFinishConfirmInfo && (
                    <ButtonAction
                        onClick={() => {
                            getDataDrawerSuggest(data?.cabinet_id, data?.device_cd);
                        }}
                        disabled={quantity === null || grindingTime === 0}
                        type={'confirm'}
                        icon="send"
                        title={t('confirm_info')}
                    />
                )}
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ConfirmFixDeviceModel;
